<template>
  <div class="flex flex-wrap gap-2 p-2">
    <button
      type="button"
      :class="[
        'flex h-7 w-7 items-center justify-center rounded-full border-2 border-border-subtle bg-surface transition-shadow',
        value === null ? 'ring-2 ring-border-strong ring-offset-1' : '',
      ]"
      @click="select(null)">
      <IconLucideBan class="h-4 w-4 text-text-muted" />
    </button>
    <button
      v-for="color in resultColors"
      :key="color.id"
      type="button"
      :style="{ backgroundColor: color.color }"
      :class="[
        'h-7 w-7 rounded-full transition-shadow',
        value === color.id ? 'ring-2 ring-border-strong ring-offset-1' : '',
      ]"
      @click="select(color.id)" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TResultColorId, IResultColor } from '@team-milva/lab-models/resources'
import { RESULT_COLORS } from '@team-milva/lab-models/resources'

export default {
  name: 'ColorPickerMenu',

  emits: ['close'],

  props: {
    value: {
      type: String as PropType<TResultColorId | null>,
      default: null,
    },
    onSelect: {
      type: Function as PropType<(colorId: TResultColorId | null) => void>,
      required: true,
    },
  },

  computed: {
    resultColors(): Array<IResultColor & { id: TResultColorId }> {
      return Object.values(RESULT_COLORS) as Array<IResultColor & { id: TResultColorId }>
    },
  },

  methods: {
    select(colorId: TResultColorId | null): void {
      this.onSelect(colorId)
      this.$emit('close')
    },
  },
}
</script>
